import type { ConsumptionSheetERPSettings } from './ConsumptionSheetERPSettings'
import type { StockERPSettings } from './StockERPSettings'
import type { CustomerERPSettings } from './CustomerERPSettings'
import type { NewsERPSettings } from './NewsERPSettings'
import type { UserSessionERPSettings } from './UserSessionERPSettings'
import type { SupplierERPSettings } from './SupplierERPSettings'
import type { IntegrationERPSettings } from './IntegrationERPSettings'
import type { CarrierERPSettings } from './CarrierERPSettings'
import type { ProductCategoryERPSettings } from './ProductCategoryERPSettings'
import type { ConsumptionSheetProducts } from './ConsumptionSheetProducts'

export enum ThemeOption {
  Auto = 'auto',
  Light = 'light',
  Dark = 'dark'
}

export interface ERPSettings {
  news?: NewsERPSettings
  consumptionSheet?: ConsumptionSheetERPSettings
  userSession?: UserSessionERPSettings
  productCategory?: ProductCategoryERPSettings
  stock?: StockERPSettings
  customer?: CustomerERPSettings
  integration?: IntegrationERPSettings
  supplier?: SupplierERPSettings
  carrier?: CarrierERPSettings
  theme?: ThemeOption
  consumptionSheetProducts?: ConsumptionSheetProducts[]
}
